import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ClickOutsideModule } from '../../directives/click-outside/click-outside.module';
import { EllipsisTooltipModule } from '../../directives/ellipsis-tooltip/ellipsis-tooltip.module';
import { SelectComponent } from './select.component';
import { SelectItemComponent } from './select-item/select-item.component';
import { StatusModule } from '../status/status.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { HighlightModule } from '../../common/highlight/highlight.module';



@NgModule({
  declarations: [SelectComponent, SelectItemComponent],
  imports: [
    CommonModule,FormsModule, ClickOutsideModule, EllipsisTooltipModule,StatusModule,CheckboxModule,HighlightModule
  ],
  exports:[SelectComponent,SelectItemComponent]
})
export class SelectModule { }
